// Base styles first, so hero and section rules override them in the cascade.
import "./HomeRound5.css";
import "./pattern2/base.css";
import { useState } from "react";
import { useSearchParams } from "react-router";
import { ArchContext, useFonts, type ArchMode } from "./pattern2/bits";
import { Hero } from "./pattern2/Hero";
import { Making, Club, KindWords } from "./pattern2/SectionsA";
import { Favorites, WhereIllBe, Brands, Loop, Footer } from "./pattern2/SectionsB";
import { PALETTES, paletteStyle, type Palette } from "./pattern2/palettes";
import { ReviewBar } from "./pattern2/ReviewBar";

/* A copy of the "Color outside the pattern" homepage in the team's palette,
   with fewer arches. ?v=<palette> and ?arch=none pick the variation. */

/* Team tweaks that apply to this page only (blue-2 shares the base palettes). */
const TWEAKS: Record<string, Partial<Palette>> = {
  // Coral from the golden layout behind Chelsea and everywhere else the soft fill shows.
  periwinkle: { soft: "#E66E78" },
};
const PAGE_PALETTES = PALETTES.map(p => ({ ...p, ...TWEAKS[p.key] }));

export function HomePattern2() {
  useFonts();
  const [params] = useSearchParams();
  const [v, setV] = useState(params.get("v"));
  const [archParam, setArchParam] = useState(params.get("arch"));
  const palette = PAGE_PALETTES.find(p => p.key === v) ?? PAGE_PALETTES[0];
  const arch: ArchMode = archParam === "none" ? "none" : "one";
  // Write the URL directly: a router navigation would make ScrollManager jump to the top.
  const set = (k: string, val: string | null, apply: (x: string | null) => void) => {
    apply(val);
    const url = new URL(window.location.href);
    if (val === null) url.searchParams.delete(k); else url.searchParams.set(k, val);
    window.history.replaceState(window.history.state, "", url);
  };

  return <ArchContext.Provider value={arch}>
    <div className="h5 p2" style={paletteStyle(palette)} data-palette={palette.key}>
      <Hero />
      <Making />
      <Club />
      <KindWords />
      <Favorites />
      <WhereIllBe />
      <Brands />
      <Loop />
      <Footer />
      <ReviewBar palettes={PAGE_PALETTES} palette={palette} arch={arch} onPalette={k => set("v", k === PALETTES[0].key ? null : k, setV)} onArch={a => set("arch", a === "one" ? null : a, setArchParam)} />
    </div>
  </ArchContext.Provider>;
}
